import Breadcrumb, { Item } from '@/components/common/Breadcrumb';
import { ROUTE } from '@/routes';
import { useNavigate } from 'react-router-dom';
import { EditDoctor } from './components';

export default function DoctorForm() {
  const navigate = useNavigate();

  const breadcrumbItems = () => {
    return [
      { label: 'Doctor Management', path: ROUTE.DOCTOR_MANAGEMENT },
      {
        label: 'Add doctor',
        path: ROUTE.ADD_DOCTOR,
      },
    ];
  };

  const handleNavigation = (item: Item) => {
    if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <div
      className="relative p-8 h-full overflow-y-scroll"
      style={{ background: '#f8f8ff' }}
    >
      <Breadcrumb items={breadcrumbItems()} onClick={handleNavigation} />
      <div className="mt-5 gap-4 flex flex-col">
        <h1 className="font-medium text-2xl">Add Doctor</h1>
        <EditDoctor />
      </div>
    </div>
  );
}
